var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { FastForward, FastRewind, Pause, PlayArrow } from 'material-ui-icons';
import { connect } from 'react-redux';
import { sendUpdateMessage } from '../../websocket';
import Button from 'material-ui/Button';
export var BUTTON_STYLE = {
    width: 48,
    minWidth: 48,
    height: 48,
    margin: 5,
};
var Tracking = /** @class */ (function (_super) {
    __extends(Tracking, _super);
    function Tracking() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onPlayPause = function () {
            var _a = _this.props, playing = _a.playing, playMessageName = _a.playMessageName;
            _this.props.dispatch(sendUpdateMessage(playMessageName, !playing));
        };
        _this.onRewind = function () {
            _this.onSkip(-(_this.props.skipValue));
        };
        _this.onForward = function () {
            _this.onSkip(_this.props.skipValue);
        };
        return _this;
    }
    Tracking.prototype.render = function () {
        var disabled = this.props.disabled;
        return (React.createElement("div", { style: { textAlign: 'center' } },
            React.createElement(Button, { style: BUTTON_STYLE, variant: "raised", onClick: this.onRewind, disabled: disabled },
                React.createElement(FastRewind, null)),
            React.createElement(Button, { color: "primary", style: BUTTON_STYLE, variant: "raised", onClick: this.onPlayPause, disabled: disabled }, this.props.playing ? React.createElement(Pause, null) : React.createElement(PlayArrow, null)),
            React.createElement(Button, { style: BUTTON_STYLE, variant: "raised", disabled: disabled, onClick: this.onForward },
                React.createElement(FastForward, null))));
    };
    Tracking.prototype.onSkip = function (value) {
        this.props.dispatch(sendUpdateMessage(this.props.skipMessageName, value));
    };
    return Tracking;
}(React.Component));
export default connect()(Tracking);



//////////////////
// WEBPACK FOOTER
// ./src/components/VehicleController/Tracking.tsx
// module id = 1817
// module chunks = 0